/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input, OnInit } from '@angular/core';
import { FeedbackScoresProvider, GeneratedReportFeedbackProvidersSection } from '@app/app/shared/models';

@Component({
  selector: 'ptl-feedback-providers-report-learner-section',
  templateUrl: './providers-section.component.html',
  styleUrls: ['./providers-section.component.scss'],
})
export class ProvidersSectionComponent implements OnInit {
  @Input() section: GeneratedReportFeedbackProvidersSection;

  allLoaded = false;
  feedbackProviders: FeedbackScoresProvider[] = [];

  ngOnInit(): void {
    if (this.section) {
      this.feedbackProviders = this.section.feedbackProviders.slice(0, 4);
    }
  }

  showMore(): void {
    this.feedbackProviders = this.section.feedbackProviders;
    this.allLoaded = true;
  }
}
